import { RefObject, useEffect } from 'react';

const useOutsideClick = (ref: RefObject<HTMLElement>, callback: () => void): void => {
  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();

    const target = e.target as Node;

    if (ref && ref.current && target && !ref.current.contains(target as Node)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('click', handleClick);
    };
  });
};

export default useOutsideClick;
